import {
	connect
} from 'react-redux'
import OrderFlowEditComponent from '../components/OrderFlowEditComponent.jsx';

const mapStateToProps = (state) => ({
	step1Class: state.getIn(['orderReducer', 'step1Class']),
	step2Class: state.getIn(['orderReducer', 'step2Class']),
	step1Display: state.getIn(['orderReducer', 'step1Display']),
	step2Display: state.getIn(['orderReducer', 'step2Display']),
})

const mapDispatchToProps = (dispatch) => ({
})

const OrderFlowEditContainer = connect(
	mapStateToProps,
	mapDispatchToProps
)(OrderFlowEditComponent)

export default OrderFlowEditContainer;


// WEBPACK FOOTER //
// ./src/containers/OrderFlowEditContainer.jsx